import React, { useState } from 'react'
import '../css/bymanta.css'
import { motion } from 'framer-motion'

const ByManta2 = () => {


    return(
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1, transition: { duration: 0.7, delay: 3 } }} className='bymanta' style={{ bottom: '1rem', position: 'fixed', display: 'flex', height: '22px', width: '1px', zIndex: 800 }}>
          <div style={{ width: '0px', position: 'absolute', marginLeft: '-3px'  }}>
            <div style={{ height: '22px', width: '200px', transformOrigin: 'left center', transform: 'rotate( 270deg )', cursor: 'pointer' }}><h5 style={{ marginTop: '0px' }}>BY &nbsp;
              <motion.a style={{ textDecoration: "none" }} whileHover={{ letterSpacing: "0.3em" }} transition={{ duration: 0.3 }} href='https://manta.studio' target="_blank"><strong>MANTA</strong></motion.a></h5></div>
          </div>
        </motion.div>
    ) 

}

export default ByManta2